import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Gift = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 25' {...rest}>
    {type === 'stroke' ? (
      <>
        <path
          d='M19.094 12.649v6.267a2 2 0 0 1-2 2h-10a2 2 0 0 1-2-2v-6.267m14 0v-.233m0 .232a2 2 0 0 0-1-3.732h-12a2 2 0 0 0-1 3.733m14 0c-.294.17-.636.267-1 .267h-12a2 2 0 0 1-1-.268m0-.232v.232m7-3.732V7.249m0 1.667h-1.667a3.333 3.333 0 0 1-3.333-3.333c0-.92.746-1.667 1.666-1.667a3.333 3.333 0 0 1 3.334 3.333m0 1.667h1.666a3.333 3.333 0 0 0 3.334-3.333c0-.92-.746-1.667-1.667-1.667a3.333 3.333 0 0 0-3.333 3.333m0 1.667v12'
          stroke='currentColor'
          strokeWidth='1.5'
        />
      </>
    ) : (
      <>
        <path
          d='M6.094 5.583A2.667 2.667 0 0 1 8.76 2.916c1.34 0 2.539.609 3.334 1.564a4.32 4.32 0 0 1 3.333-1.564 2.667 2.667 0 0 1 2.667 2.667c0 .859-.25 1.66-.681 2.333h1.68a2 2 0 0 1 0 4h-6v-4h.667a2.333 2.333 0 0 0 2.334-2.333.667.667 0 0 0-.667-.667 2.333 2.333 0 0 0-2.333 2.333v.667h-2v-.667A2.333 2.333 0 0 0 8.76 4.916a.667.667 0 0 0-.666.667 2.333 2.333 0 0 0 2.333 2.333h.667v4h-6a2 2 0 1 1 0-4h1.681a4.3 4.3 0 0 1-.681-2.333'
          fill='currentColor'
        />
        <path d='M13.094 13.916h7v5a3 3 0 0 1-3 3h-4z' fill='currentColor' />
        <path d='M11.094 13.916h-7v5a3 3 0 0 0 3 3h4z' fill='currentColor' />
      </>
    )}
  </IconBase>
);
